import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerInfoDto } from 'src/api/v2';
import { formatOrganizationNumber } from 'src/utils/format';
import { printCustomerInfoDtoAddress } from '../../utils';
import './styles/CompanyBaseInfoBox.scss';
import { Heading, Icon } from '@innovationnorway/cl-react';

type Props = {
  company: CustomerInfoDto | undefined;
  hideName?: boolean;
  className?: string;
};

const CompanyBaseInfoBox: React.FC<Props> = ({ company: company, hideName, className }) => {
  const { t: tSiva } = useTranslation('siva');

  if (!company) {
    return null;
  }

  const address = printCustomerInfoDtoAddress(company) ?? tSiva('newCompany.baseInfoBox.noAddress');

  return (
    <div className={`company-base-info margin-bottom--3 ${className ?? ''}`}>
      {!hideName && (
        <Heading
          level={3}
          data-size="sm"
          className="font-weight--normal color--in-black-100 margin-bottom--0"
        >
          {company?.name}
        </Heading>
      )}

      <dl>
        <dt className="sr-only"></dt>
        <dd className="margin-left--0">
          <Icon prefix="fasr" iconName="building" />
          {tSiva('newCompany.baseInfoBox.orgNo')} {formatOrganizationNumber(company.publicId)}
        </dd>
        <dt className="sr-only"></dt>
        <dd className="margin-left--0 margin-bottom--1">
          <Icon prefix="fasr" iconName="location-dot" />
          {tSiva('newCompany.baseInfoBox.address')} {address}
        </dd>
      </dl>
    </div>
  );
};

export default CompanyBaseInfoBox;
